import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var TakePipe = (function () {
    function TakePipe() {
    }
    TakePipe.prototype.transform = function (input, quantity) {
        if (!isArray(input)) {
            return input;
        }
        return input.slice(0, quantity || 1);
    };
    return TakePipe;
}());
export { TakePipe };
TakePipe.decorators = [
    { type: Pipe, args: [{
                name: 'take'
            },] },
];
/** @nocollapse */
TakePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=take.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/take.pipe.js
// module id = 251
// module chunks = 103